module.exports = __webpack_public_path__ + "static/media/automated-testing.070c5942.jpg";